import { render, staticRenderFns } from "./RouteDialog.vue?vue&type=template&id=c8bc0616&scoped=true"
import script from "./RouteDialog.vue?vue&type=script&lang=js"
export * from "./RouteDialog.vue?vue&type=script&lang=js"
import style0 from "./RouteDialog.vue?vue&type=style&index=0&id=c8bc0616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bc0616",
  null
  
)

export default component.exports